import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-657be501"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center mb-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Okul Öğrenci Listesi", -1))
const _hoisted_3 = { class: "flex flex-row gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn-secondary"
}, "Arşiv", -1))
const _hoisted_5 = { class: "relative flex flex-col w-full overflow-scroll text-gray-700 bg-white shadow-md rounded-lg bg-clip-border" }
const _hoisted_6 = { class: "w-full text-left table-auto min-w-max text-slate-800" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-slate-500 border-b border-slate-300 bg-slate-50" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-4 w-24" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Öğrenci"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Okul Numarası"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Cinsiyet"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Doğum Yılı"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Veli Bilgileri"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" }, "Kayıt Tarihi"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-4" })
  ])
], -1))
const _hoisted_8 = { class: "p-4 w-10" }
const _hoisted_9 = { class: "p-4" }
const _hoisted_10 = { class: "text-sm font-bold" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "p-4" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "p-4" }
const _hoisted_18 = { class: "mb-2 p-3 text-sm border border-indigo-200 rounded-md bg-indigo-100" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "block" }
const _hoisted_22 = { class: "p-3 text-sm border border-indigo-200 rounded-md bg-indigo-100" }
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "block" }
const _hoisted_26 = { class: "p-4" }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "p-4 text-right" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
}
const _hoisted_31 = { class: "bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full" }
const _hoisted_32 = { class: "flex justify-between items-center mb-4" }
const _hoisted_33 = { class: "text-xl font-semibold" }
const _hoisted_34 = { class: "flex flex-col gap-4" }
const _hoisted_35 = { class: "grid grid-cols-4 grid-flow-row gap-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "schoolNumber",
  class: "block text-sm font-medium text-gray-700"
}, "Okul Numarası", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-sm font-medium text-gray-700"
}, "Öğrenci Adı", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "middleName",
  class: "block text-sm font-medium text-gray-700"
}, "Orta Adı", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "surname",
  class: "block text-sm font-medium text-gray-700"
}, "Soyadı", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "block text-sm font-medium text-gray-700"
}, "Cinsiyet", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Erkek" }, "Erkek", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Kız" }, "Kız", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "birthyear",
  class: "block text-sm font-medium text-gray-700"
}, "Doğum Yılı", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pt-4" }, "1. Veli Bilgileri", -1))
const _hoisted_46 = { class: "flex flex-row gap-4" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-sm font-medium text-gray-700"
}, "Ad Soyad", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "surname",
  class: "block text-sm font-medium text-gray-700"
}, "Telefon Numarası", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "middleName",
  class: "block text-sm font-medium text-gray-700"
}, "E-posta", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pt-4" }, "2. Veli Bilgileri", -1))
const _hoisted_51 = { class: "flex flex-row gap-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-sm font-medium text-gray-700"
}, "Ad Soyad", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "surname",
  class: "block text-sm font-medium text-gray-700"
}, "Telefon Numarası", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "middleName",
  class: "block text-sm font-medium text-gray-700"
}, "E-posta", -1))
const _hoisted_55 = { class: "flex justify-end space-x-4" }
const _hoisted_56 = {
  type: "submit",
  class: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2 pt-4 text-sm" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Kayıt etmek için "),
    /*#__PURE__*/_createElementVNode("kbd", { class: "kbd kbd-xs" }, "Ctrl + S")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("İptal etmek için "),
    /*#__PURE__*/_createElementVNode("kbd", { class: "kbd kbd-xs" }, "Esc")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args))),
          class: "btn-primary"
        }, "Öğrenci Ekleyin")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students, (student) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: student.studentId,
              class: "hover:bg-slate-50"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_Avatar, {
                  photoUrl: student.photoUrl,
                  name: student.name,
                  surname: student.surname
                }, null, 8, ["photoUrl", "name", "surname"])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(student.name) + " " + _toDisplayString(student.middleName) + " " + _toDisplayString(student.surname), 1)
              ]),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(student.schoolNumber), 1)
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(student.gender), 1)
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(student.birthYear), 1)
              ]),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(student.parent1FullName), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(student.parent1PhoneNumber) + " / " + _toDisplayString(student.parent1Email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(student.parent2FullName), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(student.parent2PhoneNumber) + " / " + _toDisplayString(student.parent2Email), 1)
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(student.createdAt), 1)
              ]),
              _createElementVNode("td", _hoisted_28, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editStudent(student)),
                  class: "btn-primary"
                }, " Güncelle ", 8, _hoisted_29)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.showDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.dialogTitle), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args))),
                class: "text-red-500 text-sm"
              }, " Kapat ")
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", null, [
                    _hoisted_36,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentStudent.schoolNumber) = $event)),
                      id: "schoolNumber",
                      type: "text",
                      class: "input input-bordered w-full",
                      placeholder: "Okul numarası giriniz",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.schoolNumber]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentStudent.name) = $event)),
                      id: "name",
                      type: "text",
                      class: "input input-bordered w-full",
                      placeholder: "Öğrenci adı giriniz",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_38,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentStudent.middleName) = $event)),
                      id: "middleName",
                      type: "text",
                      class: "input input-bordered w-full",
                      placeholder: "Orta adı giriniz"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.middleName]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentStudent.surname) = $event)),
                      id: "surname",
                      type: "text",
                      class: "input input-bordered w-full",
                      placeholder: "Soyadı giriniz",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.surname]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_40,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentStudent.gender) = $event)),
                      class: "input input-bordered w-full"
                    }, _hoisted_43, 512), [
                      [_vModelSelect, _ctx.currentStudent.gender]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_44,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentStudent.birthYear) = $event)),
                      id: "surname",
                      type: "text",
                      class: "input input-bordered w-full",
                      placeholder: "Doğum Yılı",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.birthYear]
                    ])
                  ])
                ]),
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", null, [
                    _hoisted_47,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentStudent.parent1FullName) = $event)),
                      id: "name",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent1FullName]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentStudent.parent1PhoneNumber) = $event)),
                      id: "surname",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent1PhoneNumber]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentStudent.parent1Email) = $event)),
                      id: "middleName",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent1Email]
                    ])
                  ])
                ]),
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", null, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentStudent.parent2FullName) = $event)),
                      id: "name",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent2FullName]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_53,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentStudent.parent2PhoneNumber) = $event)),
                      id: "surname",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent2PhoneNumber]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_54,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentStudent.parent2Email) = $event)),
                      id: "middleName",
                      type: "text",
                      class: "input input-bordered w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.currentStudent.parent2Email]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("button", _hoisted_56, _toDisplayString(_ctx.currentStudent.studentId ? 'Güncelle' : 'Kaydet'), 1)
                ])
              ])
            ], 32),
            _hoisted_57
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}